const mutations = {
  setCode(state, data) {
    state.code = data;
  },
  setTitleInfo(state, data) {
    if (data.title.length > 0) {
      state.titleInfo.title = data.title;
    }
    state.titleInfo.bg = data.bg;
    state.isMore = data.isMore;
  },
  setUserInfo(state, data) {
    state.userInfo = data;
  },
  setDingDingconfig(state, data) {
    state.dingdingconfig = data;
  },
  setBrowser(state, data) {
    state.browser = data;
  },
  setHistoryPageName(state, data) {
    state.historyPageName = data;
  }
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js